export function environment(hostname = window.location.hostname) {
    // split the current url into pieces
    const urlParts = hostname.split('.');
    // grab the first piece
    let subdomain = urlParts[0];
    let domain;
    
    // default to prod if local or demo
    if (subdomain === 'demo' || subdomain === '') {
        subdomain = 'www';
    }
    if (subdomain === 'localhost' || subdomain.indexOf('igpc') === 0 || subdomain.indexOf('127') === 0) {
        subdomain = 'local';
    }
    
    switch (subdomain) {
        case 'local':
        case 'net':
        case 'net-local':
        case 'net-deal':
            domain = 'net';
            break;
        case 'net-remote':
            domain = 'net-remote';
            break;
        case 'web':
        case 'web-deal':
        case 'origin-web':
            domain = 'web';
            break;
        default:
            domain = 'www';
    }
    return domain;
}